import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { hook } from '@g4/automation-hooks';
import { TrackClick } from '@g4/trackster';
import { useTranslations } from '../../graphql/components/ApplicationQueryProvider';
import { Text, Media, Box } from '../../components/Boneyard';
import {
  EMAIL_SIGN_UP_EXPAND,
  EMAIL_SIGN_UP_COLLAPSED_TEXT,
} from '../../../automationHooks';
import EmailSignUpCard from './emailSignUp/EmailSignUpCard';

import EMAIL_ICON from '../../images/ic-email-white.svg';

const EmailIcon = styled.div`
  width: 38px;
  background-image: url(${EMAIL_ICON});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: ${props => props.theme.spacing(2)};
`;

const Container = styled.div`
  width: 100vw;
  z-index: ${props => props.theme.zIndex.emailSignUp};
  ${props => props.theme.query.md} {
    height: 1px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Wrapper = styled.div`
  position: absolute;
  z-index: 1;
  right: 0;
  top: -20px;
  box-shadow: 0 3px 6px 0 rgba(38, 50, 56, 0.4);
  border-radius: 8px;
  max-width: 744px;
`;

const Strip = styled.div`
  display: flex;
  width: 138px;
  border-bottom: 8px solid ${props => props.theme.colors.emailSignUp.border};
  background-color: ${props => props.theme.colors.emailSignUp.stripBackground};
  text-transform: uppercase;
  border-radius: 8px 0 0 8px;
  padding: 12px;
  cursor: pointer;
`;

const EmailSignUp = ({ theme }) => {
  const [isCollapsed, setIsCollapsed] = React.useState(true);
  const toggle = () => setIsCollapsed(!isCollapsed);

  const translations = useTranslations();

  const { collapsedText } = translations.emailSignUp;

  return (
    <Media>
      {mq => (
        <>
          {mq.gte('md') ? (
            <Container>
              <Box fullwidth position="relative">
                <Wrapper>
                  {isCollapsed ? (
                    <TrackClick
                      category="site_click_tracking"
                      action="Homepage"
                      label="Email Signup"
                    >
                      <Strip
                        onClick={toggle}
                        {...hook(EMAIL_SIGN_UP_EXPAND.hook)}
                      >
                        <EmailIcon
                          {...hook(
                            EMAIL_SIGN_UP_COLLAPSED_TEXT.hook,
                            'mail-icon'
                          )}
                        />
                        <Text
                          size={10}
                          weight={500}
                          color={theme.colors.emailSignUp.titleColor}
                          automationHook={EMAIL_SIGN_UP_COLLAPSED_TEXT.hook}
                        >
                          {collapsedText}
                        </Text>
                      </Strip>
                    </TrackClick>
                  ) : (
                    <EmailSignUpCard handleClick={toggle} theme={theme} />
                  )}
                </Wrapper>
              </Box>
            </Container>
          ) : (
            <EmailSignUpCard theme={theme} />
          )}
        </>
      )}
    </Media>
  );
};

EmailSignUp.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default withTheme(EmailSignUp);
